import NzRollReturnsAdapter from './base';

export default class ValidationResult extends NzRollReturnsAdapter {
  modelNamePlural = 'validationResults';
}
